module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/murin3-ca910b6fff6ca8c46fb900b82e971561.jpg";